export default {
  // General
  RESET_ERRORS: "RESET_ERRORS",
  RESET_STATE: "RESET_STATE",

  // Profile related
  AUTH_REQUEST: "AUTH_REQUEST",
  AUTH_SUCCESS: "AUTH_SUCCESS",
  AUTH_ERROR: "AUTH_ERROR",

  LOGOUT_REQUEST: "LOGOUT_REQUEST",
  LOGOUT_ERROR: "LOGOUT_ERROR",

  PROFILE_REQUEST: "PROFILE_REQUEST",
  PROFILE_SUCCESS: "PROFILE_SUCCESS",
  PROFILE_ERROR: "PROFILE_ERROR",

  PASSWORD_RESTORE_LINK_REQUEST: "PASSWORD_RESTORE_LINK_REQUEST",
  PASSWORD_RESTORE_LINK_SUCCESS: "PASSWORD_RESTORE_LINK_SUCCESS",
  PASSWORD_RESTORE_LINK_ERROR: "PASSWORD_RESTORE_LINK_ERROR",

  PASSWORD_RESTORE_RESET_REQUEST: "PASSWORD_RESTORE_RESET_REQUEST",
  PASSWORD_RESTORE_RESET_SUCCESS: "PASSWORD_RESTORE_RESET_SUCCESS",
  PASSWORD_RESTORE_RESET_ERROR: "PASSWORD_RESTORE_RESET_ERROR"
};
